export const LINKORDER_LIST = {
    name: '券核销列表',
    api: '${BASE}/bcp-coupon-dev/api/B/orderWriteOff/listForOrder',
    doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612161',
    method: 'post'
};
export const LINKORDER_LINK = {
    name: '关联订单',
    api: '${BASE}/bcp-coupon-dev/api/B/orderWriteOff/relation',
    doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612173',
    method: 'post',
}

export const LOG_OUT = {
    name: '退出登录',
    api: '${BASE}/bcp-basic-data-dev/api/B/user/logout',
    doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=17696435',
}